module.exports = __webpack_public_path__ + "assets/d44011a7514cdee2d02052ed5633d247.png";